import { Drawer, Loading } from "@components";
import { Titles } from "../../variables/Titles";

import { OlgaEnvironmentsAPI } from "@providers/OlgaEnvironmentsAPI";
import { useEffect, useState } from "react";
import FixedValueForm from "../types/FixedValueForm";

export const OrderUnitForm = ({
  visible,
  onClose,
  node,
  onChange,
  onSave,
  onRemove,
}) => {
  const [units, setUnits] = useState([]);
  const [loading, setLoading] = useState([]);

  const loadUnits = async () => {
    setLoading(true);
    const response = await OlgaEnvironmentsAPI.getUnits();
    const list = response.getData([]);
    setUnits(list.map((u) => ({ label: u.name, value: u.id })));
    setLoading(false);
  };

  useEffect(() => {
    if (visible) {
      loadUnits();
    }
  }, [visible]);

  const loading_style = {
    height: "100vh",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  };

  return (
    <Drawer
      visible={visible}
      onClose={() => onClose()}
      title={Titles.OrderUnit}
      direction="center-right"
      parentSelector={() => document.getElementById("oracle-flow")}
    >
      {loading ? (
        <div style={loading_style}>
          <Loading />
        </div>
      ) : (
        <FixedValueForm
          node={node}
          options={units}
          onSave={(node) => onSave(node)}
          onRemove={onRemove}
        />
      )}
    </Drawer>
  );
};
